(() => {
  angular
    .module('gm.common.exchange', [
      'gm.common.websockets'
    ])
    .factory('gmExchange', gmExchangeFactory);

  function gmExchangeFactory(
    $rootScope,
    $q,
    gmSocketFactory
  ) {
    'ngInject';

    let connectionDeferred;

    const exchange = {
      USD: {
        USD: 1,
        GAU: 0
      },
      GAU: {
        USD: 0,
        GAU: 1
      }
    };
    const exchangeObserverCallbacks = [];
    const METAL_CODE = {
      GAU: 'GAU',
      XAG: 'XAG',
      XPD: 'XPD',
      XPT: 'XPT'
    };

    function calculateMetalPrice(metalCode, currencyCode, inUSD) {
      if (!exchange[metalCode]) {
        return 0;
      }

      if (currencyCode === metalCode) {
        return 1;
      }

      return exchange[metalCode].USD / ((metalCode === METAL_CODE.XAG) ? (inUSD * 1000) : inUSD);
    }

    function recalculateAll() {
      Object.keys(exchange).forEach((currencyCode) => {
        exchange[currencyCode].GAU = calculateMetalPrice(METAL_CODE.GAU, currencyCode,
          exchange[currencyCode].USD);
        exchange[currencyCode].XAG = calculateMetalPrice(METAL_CODE.XAG, currencyCode,
          exchange[currencyCode].USD);
        exchange[currencyCode].XPD = calculateMetalPrice(METAL_CODE.XPD, currencyCode,
          exchange[currencyCode].USD);
        exchange[currencyCode].XPT = calculateMetalPrice(METAL_CODE.XPT, currencyCode,
          exchange[currencyCode].USD);
      });
    }

    exchange.connect = function _connect() {
      if (!connectionDeferred) {
        connectionDeferred = $q.defer();
        const socket = gmSocketFactory.create('/ws/exchange-rates');

        socket.on('message', (data) => {
          let rates;

          if (data && data.rates) {
            rates = data.rates;

            $rootScope.$apply(() => {
              Object.keys(rates).forEach((currencyCode) => {
                exchange[currencyCode] = {
                  USD: rates[currencyCode],
                  GAU: calculateMetalPrice(METAL_CODE.GAU, currencyCode, rates[currencyCode]),
                  XAG: calculateMetalPrice(METAL_CODE.XAG, currencyCode, rates[currencyCode]),
                  XPD: calculateMetalPrice(METAL_CODE.XPD, currencyCode, rates[currencyCode]),
                  XPT: calculateMetalPrice(METAL_CODE.XPT, currencyCode, rates[currencyCode])
                };

                if (currencyCode in METAL_CODE) {
                  recalculateAll();
                }
              });

              // notify observers
              exchange.notifyExchangeObservers(rates);
            });
          }
        });

        socket.once('message', () => {
          connectionDeferred.resolve();
        });
        socket.connect();
      }
      return connectionDeferred.promise;
    };

    exchange.notifyExchangeObservers = function _notifyExchangeObservers(rates) {
      angular.forEach(exchangeObserverCallbacks, (callback) => {
        callback(rates);
      });
    };

    exchange.registerExchangeObserver = function _registerExchangeObserver(callback) {
      exchangeObserverCallbacks.push(callback);
    };

    $rootScope.exchange = exchange;

    return exchange;
  }
})();
